module.exports = __webpack_public_path__ + "static/media/placeholder.92686ea3.jpg";